import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useTrip } from "@/hooks/queries";
import { PageLoader } from "@/components/common";
import { TripHero, TripInfo } from "@/components/trip/TripInfo";
import { PackagePicker } from "@/components/trip/PackagePicker";
import { BookingCalendar } from "@/components/booking/BookingCalendar";
import { BookingForm } from "@/components/booking/BookingForm";

const TripNotFound = () => (
  <section className="mx-auto max-w-3xl px-5 pb-24 pt-40 text-center" data-testid="trip-not-found">
    <h1 className="font-display text-4xl">Trip tidak ditemukan</h1>
    <p className="mt-4 text-neutral-500">Trip ini mungkin sudah tidak tersedia.</p>
    <Link to="/#trip" className="btn-gold mt-8">Lihat semua trip</Link>
  </section>
);

export default function TripDetail() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const { data: trip, isLoading, isError } = useTrip(id);
  const [pkgId, setPkgId] = useState(params.get("paket"));
  const [date, setDate] = useState(params.get("tanggal"));

  if (isLoading) return <PageLoader className="min-h-screen" />;
  if (isError || !trip) return <TripNotFound />;
  const pkg = trip.packages.find((p) => p.id === pkgId) || trip.packages[0];

  return (
    <>
      <TripHero trip={trip} />
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:py-24 lg:grid-cols-12">
        <div className="space-y-14 lg:col-span-7">
          <PackagePicker packages={trip.packages} value={pkg.id} onChange={setPkgId} />
          <TripInfo trip={trip} pkg={pkg} />
        </div>
        <aside className="space-y-6 lg:col-span-5">
          <BookingCalendar tripId={trip.id} duration={pkg.duration_days} value={date} onChange={setDate} />
          <BookingForm trip={trip} pkg={pkg} date={date} />
        </aside>
      </section>
    </>
  );
}
